module.exports = __webpack_public_path__ + "img/3000.da26b3c8.jpg";